<template>
    <div class="header">
        <div class="row left-row">
            <div class="logo">
                <a
                    :href="computedHref"
                    :target="isExternal ? '_blank' : null"
                    :style="!isExternal ? { cursor: 'default' } : null"
                    @click="logoClickHandler"
                >
                    <img 
                        :src="logoComputed" 
                        :style="{height: logo.height, opacity: hideLogo ? 0 : 1}" 
                        :class="{hide: !logoComputed}" 
                        @error="errorHandler"
                    />
                    <span :class="{hide: logoComputed}">
                        <span class="brand">{{ tokens.header.cfd }}</span> 
                        {{ tokens.header.platform }}
                    </span>
                </a>
            </div>
            <div class="layout nomobile" v-on:click="showGridsModal" :class="{hide: multigrid !== '1'}">
                <i class="material-icons">dashboard</i>
            </div>
            <div class="active-symbols">
                <div class="item"
                     v-for="(chart, i) in charts"
                     :key="i"
                     :class="{
                         active: chart.id === chartActive,
                         enabled: enabledList.indexOf(chart.id) !== -1,
                         inprofit: orderData[chart.symbol] && orderData[chart.symbol].profit > 0,
                         inloss: orderData[chart.symbol] && orderData[chart.symbol].profit < 0
                     }"
                     v-on:click="makeActive(chart.id)"
                >
                    <div class="symbol" :class="chart.symbol ? 'symbol-'+chart.symbol.toUpperCase() : ''" />
<!--                    <img :src="staticBase+chart.symbol.toUpperCase()+'.png'"/>-->
                    <div class="col nomobile">
                        <span class="sym">{{symbols[chart.symbol] ? symbols[chart.symbol].alias : ''}}</span>
                        <span :class="{
                            profit: orderData[chart.symbol],
                            green: orderData[chart.symbol] && orderData[chart.symbol].profit > 0,
                            red: orderData[chart.symbol] && orderData[chart.symbol].profit < 0
                        }">{{orderData[chart.symbol] ? (orderData[chart.symbol].profit > 0 ? '+' : (0 > orderData[chart.symbol].profit ? '-' : ''))+currencySign(activeAccount.currency)+Math.abs(orderData[chart.symbol].profit).toFixed(activeAccount.precision) : tokens.markets[symbols[chart.symbol] ? symbols[chart.symbol].market : 'forex'].toLowerCase()}}</span>
                    </div>
                    <i class="material-icons" v-on:click.stop="hideSymbol(chart.id)">close</i>
                </div>
            </div>
            <div class="layout">
                <i class="material-icons" v-on:click="showSymbolsModal">add</i>
            </div>
        </div>
        <div class="row right-row">
            <div class="mobile-menu" v-on:click="toggleModalMenu">
                <i class="material-icons">menu</i>
            </div>
            <div class="deposit" v-on:click="showCabinet('deposit')">
                <i class="material-icons">payments</i>
                <span class="nomobile">{{ tokens.header.deposit }}</span>
            </div>
            <div class="balance" :class="activeAccount.demo ? 'brand' : 'green'" v-on:click="showBalanceModal">
                <div class="col align-end">
                    <div class="acc-type">{{ buildAccountName(activeAccount) }}</div>
                    <div class="val">
                        {{
                            currencySign(activeAccount.currency) + (
                                !showEquityHeader ? activeAccount.balance > 0 ? activeAccount.balance : 0
                                    : getEquity.equity_apprx > 0 ? getEquity.equity_apprx : 0).toLocaleString(undefined, {
                                minimumFractionDigits: activeAccount.precision,
                                maximumFractionDigits: activeAccount.precision
                            })
                        }}
                    </div>
                </div>
                <i class="material-icons">arrow_drop_down</i>
            </div>
            <div class="plate" v-if="!isMobile">
                <img :src="plate">
            </div>
            <div class="row">
                <!-- <div class="avatar" v-on:click="showAccountModal">
                    <div class="circle">
                        <i class="material-icons" :class="{hide: user.avatar}">person</i>
                        <img :src="user.avatar ? apiBase+'/avatar/'+user.avatar : ''" :class="{hide: !user.avatar}"/>
                    </div>
                </div> -->
                <div class="my-account-button" :class="{mobile: isMobile}" v-on:click="showAccountModal">
                    <span>{{ tokens.header.myAccount }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {REST_ENDPOINT, STATIC_BASE, PLATES_FOLDER, TRADINGVIEW_THEME, SHOW_EQUITY_HEADER,HIDE_LOGO, WHITE_THEME,BRAND} from "@/common/config";
    import {currencySign, isMobile} from "@/common/helpers";
    import {
        CHART_ACTIVE,
        MODAL,
        MODAL_FULLSCREEN,
        MODAL_SYMBOLS,
        SYMBOL_HIDE
    } from '@/store/mutations.type'
    import {LOGO, MULTIGRID, WEBSITE, LOGO_REDIRECT_TO} from "@/common/config"

    export default {
        name: "Header",
        mounted() {
            setInterval(() => {
                this.time = Math.floor(Date.now()/1000)
            }, 1000)

            document.addEventListener('keydown', e => {
                if(e.key === "Escape") {
                    this.hideAllModals()
                }
            })
        },
        data() {
            return {
                staticBase: STATIC_BASE,
                platesFolder: PLATES_FOLDER,
                apiBase: REST_ENDPOINT,
                website: WEBSITE,
                tradingViewTheme: TRADINGVIEW_THEME,
                time: Math.floor(Date.now()/1000),
                logo: LOGO,
                hideLogo: HIDE_LOGO,
                multigrid: MULTIGRID,
                isMobile: isMobile(),
                showEquityHeader: SHOW_EQUITY_HEADER,
                whiteTheme: WHITE_THEME,
                brand: BRAND,
                logoRedirectTo: LOGO_REDIRECT_TO
            }
        },
        methods: {
            currencySign,
            logoClickHandler(e) {
                if(this.logoRedirectTo) {
                    e.preventDefault()
                    this.showAccountModal()
                    let page = this.logoRedirectTo.replace("page:","")

                    if(page) {
                        this.$store.commit(MODAL_FULLSCREEN, {
                            page
                        })
                    }
                }
            },
            hideAllModals() {
                let allModalsFalseObject = {
                    sideMenu: true,
                    menu: this.modals.menu,
                }
                for(let n in this.modals) {
                    if(n === 'sideMenu' || n === 'menu' ) {
                        continue
                    }
                    allModalsFalseObject[n] = false
                }
                this.$store.commit(MODAL, allModalsFalseObject)
            },
            showSymbolsModal() {
                this.$store.commit(MODAL, {
                    symbols: true
                })
                this.$store.commit(MODAL_SYMBOLS, {
                    action: 'add',
                    symbolActive: null
                })
            },
            showAccountModal() {
                this.$store.commit(MODAL, {
                    fullscreen: true
                })

                this.$store.commit(MODAL,{
                    hamburgerMenu: false
                })
            },
            showBalanceModal() {
                this.$store.commit(MODAL, {
                    balance: true
                })
            },
            showGridsModal() {
                this.$store.commit(MODAL, {
                    grids: true
                })
            },
            hideSymbol(id) {
                this.$store.commit(SYMBOL_HIDE, id)
            },
            makeActive(id) {
                if (id === this.chartActive) {
                    let gridId = undefined

                    for(let n in this.gridCharts) {
                        if (this.gridCharts[n] === id) {
                            gridId = n
                            break
                        }
                    }

                    this.$store.commit(MODAL, {
                        symbols: true
                    })
                    this.$store.commit(MODAL_SYMBOLS, {
                        action: 'update',
                        id,
                        gridId
                    })
                    return
                }

                this.$store.commit(CHART_ACTIVE, id)
            },
            toggleModalMenu(){
                this.$store.commit(MODAL, this.modals.hamburgerMenu ? {
                    hamburgerMenu: false
                    } : {
                    hamburgerMenu: true
                    })
            },
            showCabinet(page) {
                this.$store.commit(MODAL, {
                    fullscreen: true,
                })
                this.$store.commit(MODAL_FULLSCREEN, {
                    page
                })
            },
            errorHandler(){
                this.logo.url = ''
            },

            buildAccountName(account) {
                return `${account.group === 'main' ? 'STANDARD' : account.group.toUpperCase().replace(/_\d+/,"")} ${this.tokens.balanceModal.account}`
            }
        },
        computed: {
            ...mapGetters(['charts', 'symbols', 'activeAccount', 'chartActive', 'gridCharts', 'user', 'themeColors', 'tokens', 'modals','lightTheme', 'langActive']),
            getEquity() {
                let b = {
                    balance: 0,
                    orders: 0,
                    profit: 0,
                    credit: 0,
                    margin: 0,
                    equity_apprx: 0
                }

                if (!this.activeAccount.id) {
                    return b
                }

                b.balance = this.activeAccount.balance
                b.credit = this.activeAccount.credit

                for(let n in this.activeAccount.orders) {
                    let o = this.activeAccount.orders[n]

                    o.easy_amount = o.easy_amount || o.margin

                    b.orders += o.easy_amount

                    if (!this.symbols[o.symbol]) {
                        continue
                    }

                    b.profit += o.type < 2 ? (o.point * (o.type ? o.price_open - this.symbols[o.symbol].quote.ask : this.symbols[o.symbol].quote.bid - o.price_open) * Math.pow(10, this.symbols[o.symbol].precision) + o.swap + o.commission) : 0
                }

                b.equity = b.balance + b.credit + b.profit
                b.equity_apprx =  b.equity

                return b
            },
            orderData() {
                let data = {}

                for(let n in this.activeAccount.orders) {
                    let ord = this.activeAccount.orders[n]

                    if (data[ord.symbol] === undefined) {
                        data[ord.symbol] = {
                            expiration: 0,
                            profit: 0,
                            completed: 0,
                            total: 0,
                            left: 0
                        }
                    }

                    if (this.symbols[ord.symbol] === undefined) {
                        continue
                    }

                    data[ord.symbol].profit += ord.type < 2 ? (ord.point * (ord.type ? ord.price_open - this.symbols[ord.symbol].quote.ask : this.symbols[ord.symbol].quote.bid - ord.price_open) * Math.pow(10, this.symbols[ord.symbol].precision) + ord.swap + ord.commission) : 0
                }

                return data
            },
            enabledList() {
                let list = []

                for(let n in this.gridCharts) {
                    if (this.gridCharts[n] !== undefined) {
                        list.push(this.gridCharts[n])
                    }
                }

                return list
            },
            plate() {
                let metal = ['tester','beginner', 'student', 'basic','basicx', 'bronze', 'bronze_plus', 'silver', 'silver_plus', 'gold', 'platinum', 'platinum_plus', 'vip', 'top', 'diamond','aitop','pro','pro_1','pro_2','diamond_2','vip_2','platinum_2','gold_2','corporate','arbitrage','shielded', 'non_investor', 'islamic', 'day_trading', 'gas_fees','low_leverage', 'demo','astr','canada','business','ai_bot','referral_silver','referral_gold','referral_vip', 'premium', 'momentum', 'essential', 'signature', 'premier', 'eliteblack', 'superclass'].includes(this.activeAccount.group) ? this.activeAccount.group : 'main'
                return '../image/' + this.platesFolder + '/' + metal + '_plate.png'
            },

            logoComputed() {
                let url = `../brands/${BRAND}/logo-white.png`

                if(this.whiteTheme){
                    return this.lightTheme ? url.replace(/white/, 'black') : url
                }else{
                    return this.tradingViewTheme === 'Light' ? url.replace(/white/, 'black') : url
                }
            },
            isExternal() {
                return this.website !== '0'
            },
            computedHref() {
                return this.isExternal ? this.logoRedirectTo || this.website : this.logoRedirectTo || '#'
            }
        }
    }
</script>

<style scoped>
    .header {
        flex: 0 0 80px;
        display: flex;
        align-items: center;
        padding: 15px;
        border-bottom: 1px solid var(--border);
        justify-content: space-between;
        background: var(--background-dark);
    }

    .left-row {
        overflow: hidden;
        flex: 1 1 auto;
        flex-wrap: nowrap;
    }

    .right-row {
        display: flex;
        flex: 0 1 450px;
        justify-content: flex-end;
        flex-direction: row;
        flex-wrap: nowrap;
    }

    .logo {
        display: flex;
        align-items: center;
        margin-right: 10px;
    }

    .logo span {
        font-size: 24px;
        font-weight: 800;
    }

    .logo img {
        max-height: 50px;
        max-width: 200px;
    }

    .logo a {
        text-decoration: none;
    }

    .layout {
        flex: 0 0 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 50px;
        border: 1px solid var(--border);
        border-radius: 5px;
        margin: 0 15px;
        cursor: pointer;
        transition: background-color ease-in-out 0.3s, color ease-in-out 0.3s;
    }

    .layout:hover {
        color: white;
        background-color: var(--background-light);
    }
    .light-theme .layout:hover {
        color: var(--white-to-black);
        background-color: var(--hover-color);
    }

    .layout i {
        font-size: 36px;
    }

    .active-symbols {
        display: flex;
        align-items: center;
        overflow-x: scroll;
        flex-wrap: nowrap;
        margin-left: 20px;
    }

    .noscroll {
        overflow-x: auto;
        overflow-y: auto;
        scroll-width: thin
    }

    .active-symbols .item {
        border: 1px solid var(--border);
        border-radius: 5px;
        background-color: transparent;
        cursor: pointer;
        height: 50px;
        display: flex;
        align-items: center;
        transition: background-color ease-in-out 0.3s;
        padding: 10px 20px;
        font-weight: 600;
        position: relative;
        margin-right: 10px;
        min-width: 135px;
    }

    .active-symbols .item.enabled:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2px;
        background: var(--white);
    }

    .active-symbols .item.active:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2px;
        background: var(--brand);
    }

    .active-symbols .item:last-child {
        margin-right: 0;
    }

    .active-symbols .item.inprofit {
        background: var(--background-dark-mid);
        background: linear-gradient(180deg, rgba(43,171,64,0.3) 0%, rgba(55,64,84,0.5) 50%);
    }

    .active-symbols .item.inloss {
        background: var(--background-dark-mid);
        background: linear-gradient(180deg, rgba(221,73,49,0.3) 0%, rgba(55,64,84,0.5) 50%);
    }

    .light-theme .active-symbols .item.inprofit {
        background: linear-gradient(180deg, rgba(95, 227, 117, 0.3) 0%, rgba(215, 225, 248, 0.5) 50%);
    }
    .light-theme .active-symbols .item.inloss {
        background: linear-gradient(180deg, rgba(247, 109, 88, 0.3) 0%, rgba(215, 225, 248, 0.5) 50%);
    }

    .active-symbols .item img {
        height: 25px;
        width: 25px;
        margin-right: 10px;
    }

    .active-symbols .symbol {
        zoom: 0.390625;
        margin-right: 25px;
    }

    @-moz-document url-prefix() {
        .active-symbols .symbol {
            -moz-transform: scale(0.390625);
            -moz-transform-origin: 50% 50%;
            position: absolute;
            left: 0;
        }

        .active-symbols .item .col {
            margin-left: 35px;
        }
    }

    .active-symbols .item .sym {
        color: var(--white-to-black);
        margin-bottom: 3px;
    }

    .active-symbols .item i {
        position: absolute;
        top: 2px;
        left: 2px;
        font-size: 14px;
        cursor: pointer;
    }

    .active-symbols .item:hover {
        background-color: var(--background-light);
    }

    .avatar {
        cursor: pointer;
        transition: color ease-in-out 0.3s;
        display: flex;
        align-items: center;
    }

    .avatar .circle {
        height: 50px;
        width: 50px;
        border-radius: 50%;
        background-color: var(--background);
        transition: background-color ease-in-out 0.3s;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
    }

    .avatar .circle img {
        height: 50px;
        width: 50px;
    }

    .avatar:hover {
        color: var(--white-to-black)
    }

    .avatar:hover .circle {
        background-color: var(--background-light);
    }

    .balance {
        display: flex;
        align-items: center;
        cursor: pointer;
        font-weight: 600;
        margin: 0 20px;
        min-width: 120px;
        white-space: nowrap;
    }

    .balance .val {
        font-size: 24px;
        font-weight: 800;
    }

    .deposit {
        border: 1px solid var(--green);
        color: var(--green);
        transition: background-color ease-in-out 0.3s, color ease-in-out 0.3s;
        font-size: 20px;
        font-weight: 400;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 25px;
        border-radius: 5px;
        cursor: pointer;
        white-space: nowrap;
    }

    .deposit i {
        margin-right: 15px;
    }

    .deposit:hover {
        color: var(--white);
        background-color: var(--green);
    }

    .timer {
        position: absolute;
        top: -2px;
        left: 20px;
        color: var(--white-to-black);
        font-weight: 600;
        width: 50px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: -15px;
    }

    .margin {
        width: 35px;
        height: 50px;
    }

    .mobile-menu {
        display: none;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin-right: 15px;
        position: relative;
        z-index: 11;
    }

    .mobile-menu i {
        font-size: 2em;
        color: var(--brand)
    }

    @media (max-width: 1000px) {
        .my-account-button {
            margin-bottom: -10px;
        }

        .logo {
            flex: 0 0 100px;
            padding-right: 20px;
        }

        .row {
            flex-wrap: nowrap;
        }

        .deposit i {
            margin-right: 0;
        }
    }

    .mobile .left-row {
        display: none !important;
    }

    .mobile .header {
        flex-direction: column;
        align-items: stretch;
        width: 100%;
        flex: 0 0 36px;
        overflow: hidden;
        padding: 3px 15px;
    }

    .mobile .logo {
        flex: 0 0 100px;
        padding-right: 20px;
    }

    .mobile .logo img {
        height: auto !important;
        width: 100px;
    }

    .mobile .header .row:first-child {
        margin-bottom: 10px;
    }

    .mobile .layout {
        margin: 0 5px
    }

    .mobile .row {
        justify-content: space-between;
    }

    .mobile .mobile-menu {
        display: flex;
    }

    .mobile .deposit {
        display: none;
    }

    .mobile .circle {
        width: 25px;
        height: 25px;
    }

    .mobile .balance .col {
        flex-direction: row;
        align-items: center;
    }

    .mobile .balance .acc-type {
        margin-right: 20px;
    }

    .mobile .balance .val {
        font-size: 14px;
    }

    .noscroll {
        overflow-x: auto;
        overflow-y: auto;
        scrollbar-width: thin;
    }

    .active-symbols {
        margin-left: 20px;
    }

    .plate {
        margin: 0 20px 0 0;
        height: 50px;
    }

    .plate img {
        height: 100%;
    }

    .my-account-button{

    }

     .my-account-button {
        border: 1px solid var(--green);
        color: var(--green);
        transition: background-color ease-in-out 0.3s, color ease-in-out 0.3s;
        font-size: 20px;
        font-weight: 400;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 25px;
        border-radius: 5px;
        cursor: pointer;
        white-space: nowrap;
    }

    .my-account-button:hover {
        color: var(--white);
        background-color: var(--green);
    }
    .my-account-button.mobile {
        font-size: 12px;
        padding: 6px 10px;
        height: auto
    }

    @media (max-width: 400px) {
        .row.right-row {
            gap: 5px
        }
        .balance{
            min-width: max-content;
            margin: 0
        }

        .mobile-menu,
        .acc-type{
            margin: 0 5px !important;
        }
    }
</style>
